import { createFeatureSelector, createSelector } from "@ngrx/store";
import { CertificatControlState } from "../reducers/certificatControl.reducer";

const selectCertificatControlFeature = createFeatureSelector<CertificatControlState>('certificatControls');

export const selectAllCertificatControls = createSelector(
  selectCertificatControlFeature,
  (state: CertificatControlState) => state
)
export const selectCertificatsControlsAmount = createSelector(
  selectCertificatControlFeature,
  (state: CertificatControlState) => state.totalAmount
)
export const selectStat = createSelector(
  selectCertificatControlFeature,
  (state: CertificatControlState) => state.stat
)


